import { render } from "./NotificationTopic.vue?vue&type=template&id=1b4f33e8"
import script from "./NotificationTopic.vue?vue&type=script&lang=js"
export * from "./NotificationTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__